import { SITE, scrollToId } from "@/lib/site";

const scrollTo = scrollToId;

export const Footer = () => {
    return (
        <footer data-testid="site-footer" className="relative overflow-hidden bg-[#050B14] pt-20 pb-10 px-5 sm:px-8">
            <div className="mx-auto max-w-7xl">
                <div className="grid md:grid-cols-[1.5fr_1fr_1fr] gap-12 pb-14 border-b border-white/10">
                    <div>
                        <div className="flex items-center gap-3 mb-5">
                            <img src={SITE.logo} alt="Bhoir Group logo" className="h-12 w-12 rounded-full object-cover ring-2 ring-white/10" />
                            <div>
                                <p className="font-display text-lg font-extrabold text-white leading-none">BHOIR GROUP</p>
                                <p className="text-[10px] tracking-[0.3em] text-[#F47B20] font-semibold">OF SERVICES</p>
                            </div>
                        </div>
                        <p className="text-slate-400 text-sm max-w-sm leading-relaxed">
                            Connecting skilled and unskilled workforce with the right
                            employers across Pune & Maharashtra. Registered company, CIN {SITE.cin}.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-semibold text-white mb-4">Explore</h4>
                        <ul className="space-y-2.5 text-sm">
                            {[["About", "about"], ["Services", "services"], ["Why Us", "manifesto"], ["Enquiry", "enquiry"], ["Contact", "contact"]].map(([l, id]) => (
                                <li key={id}>
                                    <button onClick={() => scrollTo(id)} data-testid={`footer-nav-${id}`} className="text-slate-400 hover:text-[#F47B20] transition-colors">
                                        {l}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold text-white mb-4">Contact</h4>
                        <ul className="space-y-2.5 text-sm text-slate-400">
                            {SITE.phones.map((p) => (
                                <li key={p}><a href={`tel:${p}`} className="hover:text-[#F47B20]">+91 {p}</a></li>
                            ))}
                            {SITE.emails.map((em) => (
                                <li key={em}><a href={`mailto:${em}`} className="hover:text-[#F47B20] break-all">{em}</a></li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="pt-10 select-none">
                    <p className="font-display text-[13vw] leading-none font-extrabold text-white/5 text-center tracking-tighter">
                        BHOIR GROUP
                    </p>
                </div>

                <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
                    <p>© {new Date().getFullYear()} Bhoir Group of Services. All rights reserved.</p>
                    <p>{SITE.district}, {SITE.state} — {SITE.pin}</p>
                </div>
            </div>
        </footer>
    );
};
